module.exports = __webpack_public_path__ + "static/media/Panic_core.fceb811f.png";